import * as angular from "angular";
import { Endpoints } from "../../shared/config/constant.module";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import HttpServiceName, { HttpService } from "../http/http.service";

export interface KpiService {
  getDailyProductionKPIs(selectedDate: string): angular.IPromise<apsViewModels.ProductionKPI[]>;
  getMonthlyProductionKPIs(selectedDate: string): angular.IPromise<apsViewModels.ProductionKPI[]>;  
  getLastUpdatedDates():  angular.IPromise<apsViewModels.ProductionKPIDates>;
}

class KpiServiceImpl implements KpiService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  } 

  getDailyProductionKPIs(selectedDate: string) {
    return this.httpService.get<apsViewModels.ProductionKPI[]>(
      Endpoints.PRODUCTION_KPIS_DAILY,
      {
        selectedDate: selectedDate
      });
  }

  getMonthlyProductionKPIs(selectedDate: string) {
    return this.httpService.get<apsViewModels.ProductionKPI[]>(
      Endpoints.PRODUCTION_KPIS_MONTHLY,
      {
        selectedDate: selectedDate
      });
  }  

  getLastUpdatedDates() {
    return this.httpService.get<apsViewModels.ProductionKPIDates>(
      Endpoints.PRODUCTION_KPIS_LAST_UPDATED_DATES,
      {
        
      });
  }
}

export default angular
  .module('aps.services.kpiService', [HttpServiceName])
  .service('kpiService', KpiServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/kpi.service.ts